import { gql } from '@apollo/client';
import type { ActivationTask, UserActivationTask } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLActivationTasksRequester {
  public getActivationTasks = (categories: string[]): Promise<ActivationTask[]> => {
    return graphQLRequester
      .query<{ activationTasks: ActivationTask[] }>({
        query: gql`
          query getActivationTasks {
            activationTasks {
              id
              name
              category
            }
          }
        `,
        variables: {
          categories,
        },
      })
      .then((graphQlResponse) => graphQlResponse.activationTasks);
  };

  public getUserActivationTasks = (): Promise<UserActivationTask[]> => {
    return graphQLRequester
      .query<{ userActivationTasks: UserActivationTask[] }>({
        query: gql`
          query getUserActivationTasks {
            userActivationTasks {
              user_id
              step_id
              name
              category
              finished
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.userActivationTasks);
  };

  public updateUserActivationTask = (stepId: string, finished: boolean): Promise<UserActivationTask> => {
    return graphQLRequester
      .mutate<{ updateUserActivationTask: UserActivationTask }>({
        mutation: gql`
        mutation updateUserActivationTask($input: UserActivationTaskInput!) {
          updateUserActivationTask(input: $input) {
            step_id
            finished
          }
        }
      `,
        variables: { input: { stepId, finished } },
      })
      .then((graphQlResponse) => graphQlResponse.updateUserActivationTask);
  };
}
